import React, { useState, useEffect } from 'react';
import './AppInstallBanner.css';

const AppInstallBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    };

    // Check if banner was previously dismissed
    const wasDismissed = localStorage.getItem('appBannerDismissed');
    const dismissedTime = localStorage.getItem('appBannerDismissedTime');
    
    // Show banner again after 7 days
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    const shouldShowAgain = dismissedTime && (Date.now() - parseInt(dismissedTime)) > sevenDaysInMs;

    // Show banner for all users (mobile and desktop)
    if (!wasDismissed || shouldShowAgain) {
      setIsMobile(checkMobile());
      // Show banner after 2 seconds delay for better UX
      setTimeout(() => setIsVisible(true), 2000);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('appBannerDismissed', 'true');
    localStorage.setItem('appBannerDismissedTime', Date.now().toString());
  };

  const handleInstall = () => {
    window.open('https://play.google.com/store/apps/details?id=com.prakash.shopiebazar', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="app-install-banner">
      <div className="banner-content">
        <button className="banner-close" onClick={handleClose} aria-label="Close">
          ✕
        </button>
        
        <div className="banner-icon">
          <img 
            src="/logo192.png" 
            alt="Shopie Bazar App" 
            className="app-icon"
          />
        </div>
        
        <div className="banner-text">
          <h3 className="banner-title">Get Our App! 📱</h3>
          <p className="banner-description">
            {isMobile 
              ? "Experience faster shopping with exclusive app-only deals"
              : "Download our mobile app for exclusive deals and faster checkout"
            }
          </p>
        </div>
        
        <button className="install-button" onClick={handleInstall}>
          <span className="install-icon">📥</span>
          {isMobile ? "Install Now" : "Download App"}
        </button>
      </div>
      
      <div className="banner-features">
        <div className="feature-item">
          <span className="feature-icon">⚡</span>
          <span className="feature-text">Faster Checkout</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">🎁</span>
          <span className="feature-text">Exclusive Deals</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">🔔</span>
          <span className="feature-text">Order Updates</span>
        </div>
      </div>
    </div>
  );
};

export default AppInstallBanner;
